import { useMemo, useRef, useState } from 'react';
import { Col, Row } from 'reactstrap';
import {
  addAccountTypeDefinitions,
  editAccountTypeDefinitions,
} from '../../../api/accountTypeDefinition';
import { Button, Layout } from '../../../common/components';
import { useSetLoading } from '../../../common/hooks/appearance';
import { ACTION_EDIT, ACTION_NEW } from '../../../constants/gl-configuration';
import { apiErrorHandler, successHandler } from '../../../utils/handlers';
import AccountTypeDropdown from '../common/AccountTypeDropdown';
import AddAccountTypeModal from '../common/NewAccountTypeModal';

const AccountTypeDefinition = () => {
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const toggleAccountModal = () => setIsAccountModalOpen((s) => !s);
  const [isAccountEditModalOpen, setIsAccountEditModalOpen] = useState(false);
  const toggleAccountEditModal = () => setIsAccountEditModalOpen((s) => !s);

  const dropdownRef = useRef(null);

  const [selection, setSelection] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleAccountTypeCreate = async (values) => {
    setLoading(true);
    try {
      await addAccountTypeDefinitions({ name: values.title });
      if (dropdownRef?.current) dropdownRef.current.fetchAccTypeDefData();
      toggleAccountModal();
      successHandler({
        message: {
          message: 'Account Type Created Successfully',
          title: 'Success',
        },
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      apiErrorHandler(err);
    }
  };

  const handleAccountTypeEdit = async (values) => {
    setLoading(true);
    try {
      await editAccountTypeDefinitions({
        name: values.title,
        accountTypeId: selection?.value,
      });
      if (dropdownRef?.current) dropdownRef.current.fetchAccTypeDefData();
      toggleAccountEditModal();
      setSelection(null);
      successHandler({
        message: {
          message: 'Account Type Edited Successfully',
          title: 'Success',
        },
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      apiErrorHandler(err);
    }
  };

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <Layout>
      <div className="atd-div atd-div-1">
        <h4 className="atd-heading">Accounting Type Definition</h4>
        <div className="atd-block">
          <h4 className="atd-block-heading">Account Type</h4>
          <Row>
            <Col lg="9" className=" account-number-input">
              <AccountTypeDropdown
                selection={selection}
                setSelection={setSelection}
                ref={dropdownRef}
              />
            </Col>
            <Col lg="1" className="atd-btn-section">
              <Button
                color="primary"
                className="atd-btn"
                onClick={toggleAccountModal}
                disabled={!!selection}
              >
                Add
              </Button>
            </Col>
            <Col lg="1" className="atd-btn-section">
              <Button
                color="primary"
                className="atd-btn"
                onClick={toggleAccountEditModal}
                disabled={!selection}
              >
                Edit
              </Button>
            </Col>
          </Row>
        </div>
        <AddAccountTypeModal
          isOpen={isAccountModalOpen}
          toggle={toggleAccountModal}
          onSubmit={handleAccountTypeCreate}
          section="Account Type"
          action={ACTION_NEW}
        />
        <AddAccountTypeModal
          isOpen={isAccountEditModalOpen}
          toggle={toggleAccountEditModal}
          onSubmit={handleAccountTypeEdit}
          selectedValue={selection?.label}
          section="Account Type"
          action={ACTION_EDIT}
        />
      </div>
    </Layout>
  );
};

export default AccountTypeDefinition;
